import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as amplitude from "@amplitude/analytics-browser";
import { CircleExclamation } from "@unified-checkout/design-system/icons/index";
import { PageStatus } from "@unified-checkout/design-system";
import { Announcement } from "@app/dashboard/assets/icons";
import { PERMISSIONS } from "@app/dashboard/constants/permissions";
import { SHARED_EVENTS_PARAMS } from "@app/dashboard/constants/tracking_events/shared";
import { LOCAL_STORAGE_KEYS } from "@app/dashboard/constants/local-storage-keys";
import { HOME_PAGE_EVENTS } from "@app/dashboard/constants/tracking_events/home";
import { PROFILE } from "@app/dashboard/constants/profile";
import { useIntegrationsStore } from "@app/dashboard/store/integrations";
import { useTestLiveModeStore } from "@app/dashboard/store/testLiveMode";
import { useUserInfoStore } from "@app/dashboard/store/userInfo";
import { addToLocalStorage, getFromLocalStorage } from "@app/dashboard/utils/manageLocalStorage";
import { isAccessible } from "@app/dashboard/utils/isAllowedPermission";
import { getMerchantId } from "@app/dashboard/utils/localStorageUtils";
import { getCurrentMode } from "@app/dashboard/utils/getCurrentMode";
import { AnnouncementBox } from "@app/dashboard/components/inner_layout/AnnouncementBox";
import { OnboardingFlow } from "./OnboardingFlow";
import { PayMeCard } from "@app/dashboard/components/inner_layout/PayMeCard";
import { MetricCards } from "./MetricCards";
import { usePaymentHandleConfig } from "@app/dashboard/utils/paymentHandleConfig";
import Overview from "./Overview";
import Charts from "./Charts";
import styles from "./home.module.scss";


const { ANNOUNCEMENT_BAR_SEEN } = LOCAL_STORAGE_KEYS;
const canSeeAnouncementBox = !JSON.parse(getFromLocalStorage(ANNOUNCEMENT_BAR_SEEN));

const Home = () => {
  const { isLive } = useTestLiveModeStore();
  const { t } = useTranslation();

  const {
    isError: isIntegrationsError,
    isLoading: isIntegrationsLoading,
  } = useIntegrationsStore();
  const { userInfo } = useUserInfoStore();

  const { companyName, profileType, mId } = userInfo;

  const [showAnnouncementBox, setShowAnnouncementBox] = useState(canSeeAnouncementBox);

  const canViewPayMe = profileType === PROFILE.TYPE.MERCHANT_STAFF
    ? isAccessible(PERMISSIONS.CAN_VIEW_PAYMENT_HANDLE)
    : true;

  const {
    data: paymentHandleConfig,
    isLoading: isLoadingHandle,
    isFetching: isFetchingHandle,
  } = usePaymentHandleConfig({
    enabled: canViewPayMe,
  });

  const handle = paymentHandleConfig?.handle_name || '';
  const hasPayMeHandle = Boolean(handle && handle.trim());
  const showPayMePromoCard = isLive && canViewPayMe && !hasPayMeHandle && !isLoadingHandle && !isFetchingHandle;

  useEffect(() => {
    const mid = getMerchantId();

    companyName && mid &&
      amplitude.track(HOME_PAGE_EVENTS.VIEWED, {
        [SHARED_EVENTS_PARAMS.MODE]: getCurrentMode(isLive),
        [SHARED_EVENTS_PARAMS.ACCOUNT_MID]: mid,
        [SHARED_EVENTS_PARAMS.BUSINESS_NAME]: companyName,
      });

  }, [companyName]);

  const notNowHandler = () => {
    setShowAnnouncementBox(false);
    addToLocalStorage(ANNOUNCEMENT_BAR_SEEN, true);
    amplitude.track('Home_Banner_Discard');
  };

  const customizeHandler = () => {
    amplitude.track('Home_Banner_Interaction');
  };

  return (
    <div className={styles["home-wrapper"]}>
      {
        isIntegrationsError ?
          <PageStatus
            status={isIntegrationsError ? "error" : 'warning'}
            title={isIntegrationsError && t('innerLayout.errors.smthWentWrong')}
            description={t('innerLayout.errors.dataRetrievalErr')}
            icon={CircleExclamation}
          />
          :
          <>
            <OnboardingFlow />
            
            {showPayMePromoCard && <PayMeCard />}

            <Overview />

            {/* <AnnouncementBox
              show={showAnnouncementBox}
              title={t('innerLayout.homePage.announcementBox.perrsonalizeUrCheckoutPageTitle')}
              description={t('innerLayout.homePage.announcementBox.perrsonalizeUrCheckoutPageHint')}
              icon={Announcement}
              actionBtnsProps={[
                {
                  color: "secondary",
                  variant: "link",
                  size: "md",
                  text: t('innerLayout.notNow'),
                  onClickHandler: () => notNowHandler()
                },
                {
                  color: "primary",
                  variant: "outlined",
                  size: "md",
                  text: t('innerLayout.homePage.announcementBox.customizeNow'),
                  onClickHandler: () => customizeHandler()
                }
              ]}
            /> */}

            <MetricCards />

            <Charts />
          </>
      }
    </div>
  )
}

export default Home;